// src/app/services/image-upload.service.ts
import { Injectable } from '@angular/core';
import { Storage, ref, uploadBytes, getDownloadURL } from '@angular/fire/storage';

@Injectable({ providedIn: 'root' })
export class ImageUploadService {
  constructor(private storage: Storage) {}

  /** Upload one image and return its download URL */
  async uploadImage(file: File, folder: string = 'rentals'): Promise<string> {
    const filePath = `${folder}/${Date.now()}_${file.name}`;
    const storageRef = ref(this.storage, filePath);
    await uploadBytes(storageRef, file);
    return await getDownloadURL(storageRef);
  }

  /** Upload multiple files */
  async uploadImages(files: FileList | File[], folder: string = 'rentals'): Promise<string[]> {
    const uploads = Array.from(files).map(file => this.uploadImage(file, folder));
    return await Promise.all(uploads);
  }
}
